module.exports = __webpack_public_path__ + "static/media/brand-refresh-caret-down.b1204b49.svg";